import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreviewSection() {
  const preview = faqs.slice(0, 4);

  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,340px)_1fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <p className="text-xs tracking-[0.3em] text-accent-300">FAQ</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">关于这本档案</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400">
            阅读前常见的几个问题。如果还有别的疑问，欢迎来信，我们会把高频问题补充到这里。
          </p>
          <Link
            to="/faq"
            className="mt-6 flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-200 transition-colors hover:border-primary-400 hover:text-primary-300"
          >
            查看全部问题 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <FaqAccordion items={preview} />
      </div>
    </section>
  );
}